import { Alert, Box, Button } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { ErrorOutline } from '@mui/icons-material';
import { AuthLayout } from '@shared/layouts';
import PageContainer from '@shared/components/container/PageContainer';
import { InitialPageLoader } from '@shared/components/InitialPageLoader';
import { useSsoCallback } from '@features/Auth/Sso';

export const SsoPage = () => {
  const { errorMsg, backToSignIn } = useSsoCallback();

  return (
    <PageContainer title="Signing in" useProductSuffix>
      <AuthLayout>
        {errorMsg ? (
          <Box
            sx={(theme) => ({
              width: '418px',
              display: 'flex',
              flexDirection: 'column',
              gap: 2,
              padding: '30px',
              borderRadius: '12px',
              backgroundColor: theme.palette.background.default,
              border: `1px solid ${theme.palette.border.default}`,
              boxShadow: `0px 10px 10px ${alpha(theme.palette.extendedGrey.darker, 0.1)}`,
            })}>
            <Alert severity="error" icon={<ErrorOutline />} role="alert" aria-live="polite">
              {errorMsg}
            </Alert>
            <Button fullWidth variant="contained" onClick={backToSignIn}>
              Back to sign in
            </Button>
          </Box>
        ) : (
          <InitialPageLoader message="Signing you in..." />
        )}
      </AuthLayout>
    </PageContainer>
  );
};
